module.exports = __webpack_public_path__ + "static/media/female.bd682d06.png";